import React from 'react';
import GoogleMapReact from 'google-map-react';

 
// import './styles/_index.scss';
 
const AnyReactComponent = ({ text }) => <div><img src={"/images/marker.png"} className={'image marker'} height={60}/></div>

const GoogleMap = (props) => {

  const handleClick = (e) => {
    // if (!e.target.closest('.marker') && !e.target.classList.contains('marker')) {
    //   document.querySelectorAll('.marker').forEach(item => item.classList.remove('active'));
    // }
  } 
  return (
    <div id="map-holder" className={'google-map'} onClick={handleClick} onKeyDown={handleClick} role="presentation">
      <GoogleMapReact
          yesIWantToUseGoogleMapApiInternals 
          bootstrapURLKeys={{ 
            key: process.env.GATSBY_MAPS_API_KEY,
            libraries:['places', 'geometry']
          }}
          defaultCenter={props.location}
          defaultZoom={14}
       //   onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, markers)}
      >
      <AnyReactComponent
          lat={props.property_map_lat}
          lng={props.property_map_lng}
          text="My Marker"
        />
      </GoogleMapReact>
    </div>
  )
}

export default GoogleMap;